import { render, staticRenderFns } from "./columnMapping.vue?vue&type=template&id=790f9371&scoped=true"
import script from "./columnMapping.vue?vue&type=script&lang=js"
export * from "./columnMapping.vue?vue&type=script&lang=js"
import style0 from "./columnMapping.vue?vue&type=style&index=0&id=790f9371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f9371",
  null
  
)

export default component.exports